import { render, staticRenderFns } from "./quick-add-form-btn.app.vue?vue&type=template&id=2a8ef3ba&"
import script from "./quick-add-form-btn.app.vue?vue&type=script&lang=js&"
export * from "./quick-add-form-btn.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports